import {Component, Inject, Input, Renderer2} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'nlrp-help-link',
    imports: [],
    templateUrl: './help-link.component.html',
    styleUrl: './help-link.component.scss'
})
export class HelpLinkComponent {
    @Input() url!: string;
    @Input() pageTitle!: string;

    title: string = 'Open the resource centre page for this tool';

    constructor(private router: Router) {}

    openHelpPage() {
        const urlTree = this.router.createUrlTree(['/help'], {
            queryParams: {
                url: this.url,
                title: this.pageTitle
            }
        });
        const url = this.router.serializeUrl(urlTree);
        window.open(url, '_blank', 'noopener, noreferrer');
    }
}
